// Budowa demonstracyjna: wczytuje plany 1.OG i 2.OG oraz to, co aplikacja w przyszłości odczyta z planów sama
// (piętra, pomieszczenia, rozdzielnice, obwody, punkty, trasy). Dane są wymyślone (plik prawda.json z narzedzia/demo).
import prawda from './prawda.json';
import { TYPY } from '../model/zdarzenia.js';
import { zapiszPlik } from '../baza.js';

const KALIBRACJA = { x0: 60, y0: 80, ptNaM: 1000 / 50 * 72 / 25.4, skala: '1:50', dokladnosc: 'dokładnie (plan wygenerowany)' };
const PLANY = { '1.OG': 'demo/demo-1og.pdf', '2.OG': 'demo/demo-2og.pdf' };

export async function wczytajDemo(zapisz, budowaId) {
  const id = (s) => `${budowaId.slice(0, 8)}-${s}`;
  let k = 0;
  for (const [pietro, url] of Object.entries(PLANY)) {
    const blob = await (await fetch(`${import.meta.env.BASE_URL}${url}`)).blob();
    const hash = await zapiszPlik(blob, { nazwa: `Demo Elektro ${pietro} Index A.pdf` });
    const dokId = id(`dok-${pietro}`);
    await zapisz(TYPY.DOKUMENT_DODANY, { id: dokId, hash, nazwa: `Demo Elektro ${pietro} Index A.pdf`, rodzaj: 'rzut', mime: 'application/pdf', rozmiar: blob.size, stron: 1, indeks: 'A' }, budowaId);
    await zapisz(TYPY.PIETRO_DODANE, { id: id(pietro), nazwa: pietro, kolejnosc: k++, dokumentId: dokId, kalibracja: KALIBRACJA }, budowaId);
  }
  for (const r of prawda.rozdzielnice) await zapisz(TYPY.ROZDZIELNICA_DODANA, { id: id(r.id), nazwa: r.id, pietroId: id(r.pietro), x: 8.8, y: 10.05 }, budowaId);
  for (const o of prawda.obwody) await zapisz(TYPY.OBWOD_DODANY, { id: id(o.id), nazwa: o.id, rozdzielnicaId: id(o.rozdzielnica), rcd: o.rcd, zabezpieczenie: 'B16' }, budowaId);
  for (const p of prawda.pomieszczenia)
    await zapisz(TYPY.POMIESZCZENIE_DODANE, { id: id(`${p.pietro}-${p.numer}`), pietroId: id(p.pietro), numer: p.numer, nazwa: p.nazwa,
      sciana: p.sciana === 'korytarz' ? 'murowana' : p.sciana, strefa: p.sciana === 'korytarz', geom: { x: p.x, y: p.y, w: p.w, h: p.h } }, budowaId);
  let n = 0;
  for (const p of prawda.punkty)
    await zapisz(TYPY.PUNKT_DODANY, { id: id(`p${n++}`), typ: p.katalog, pomieszczenieId: id(`${p.pietro}-${p.pomieszczenie}`), obwodId: id(p.obwod), x: p.x, y: p.y }, budowaId);
  for (const t of prawda.trasy)
    await zapisz(TYPY.TRASA_DODANA, { id: id(`trasa-${t.pietro}`), typ: t.typ, pietroId: id(t.pietro),
      odcinki: t.odcinki.map((o, i) => ({ id: id(`odc-${t.pietro}-${i}`), pomieszczenieId: id(`${t.pietro}-${o.strefa}`), m: o.m })) }, budowaId);
  return { punktow: n };
}
